import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { MspDisclaimer } from 'containers/Claims/components/MspDisclaimer'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { Component } from '@cms-max/medicare-api-sdk'

const MspDefaultBreadcrumb = () => {
  const { t } = useTranslation('msp')
  return (
      <BreadCrumb
        backButtonText={t('navigation.backToMyClaims')}
        width="wide"
        navAriaLabel={t('navigation.backToClaimsMainPageAriaLabelMSP')}
        backButtonLink="/claims"
        siteActivityProps={{
          core: {
            component: Component.Claims,
            coreClickData: {
              linkText: t('navigation.backToMyClaims'),
              linkUrl: buildAbsoluteMedicareMyUrl('/claims')
            },
            elementId: 'msp_backtosearch_click'
          }
        }}
      />
  )
}

type MspDisclaimerPageProps = {
  onAccept: () => void
}
export const MspDisclaimerPage = ({ onAccept }: MspDisclaimerPageProps) => {
  const { t } = useTranslation('msp')

  return (
    <>
      <MspDefaultBreadcrumb />
      <ContentLayout
        className="ds-u-padding-bottom--7"
        width="wide"
        heading={t('summary.headingMSP')}
        withPrintButton
      >
        <div className="ds-l-container my-c-msp">
          <MspDisclaimer onAccept={onAccept} />
        </div>
      </ContentLayout>
    </>
  )
}
